import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAxios from "vue-axios";
import axios from "axios";

import '@/@http/@config/interceptors/index'; // Enable interceptors

import "primeflex/primeflex.css";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "@/styles/index.scss";

const app = createApp(App);

import draggable from 'vuedraggable';
app.component('Draggable', draggable);

// Primevue
import PrimeVue from 'primevue/config';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';
import InputText from 'primevue/inputtext';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import TieredMenu from 'primevue/tieredmenu';
import DataView from 'primevue/dataview';
import InputSwitch from 'primevue/inputswitch';
import InputMask from 'primevue/inputmask';
import ConfirmationService from 'primevue/confirmationservice';
import ConfirmDialog from 'primevue/confirmdialog';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import Dropdown from 'primevue/dropdown';
import Divider from 'primevue/divider';
import ProgressBar from 'primevue/progressbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Card from "primevue/card";
import Dialog from 'primevue/dialog';
import Avatar from 'primevue/avatar';
import Toolbar from 'primevue/toolbar';
import Tooltip from 'primevue/tooltip';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import AutoComplete from 'primevue/autocomplete'
import OverlayPanel from 'primevue/overlaypanel';
import Tag from 'primevue/tag';
import Sidebar from 'primevue/sidebar';
import Message from 'primevue/message';
import Tree from 'primevue/tree';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';
import MultiSelect from 'primevue/multiselect';
import SelectButton from 'primevue/selectbutton';
import Rating from "primevue/rating";
import Paginator from "primevue/paginator";
import SplitButton from "primevue/splitbutton";
import Textarea from "primevue/textarea";
import Menu from "primevue/menu";
import Chips from "primevue/chips";
import Password from 'primevue/password';

app.use(PrimeVue);
app.use(ConfirmationService);
app.use(ToastService);
app.directive('tooltip', Tooltip);

app.component('Password', Password);
app.component('RadioButton', RadioButton);
app.component('Menu', Menu);
app.component('SplitButton', SplitButton);
app.component('InputNumber', InputNumber);
app.component('Calendar', Calendar);
app.component('Tree', Tree);
app.component('Message', Message);
app.component('Sidebar', Sidebar);
app.component('Tag', Tag);
app.component('Panel', Panel);
app.component('OverlayPanel', OverlayPanel);
app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('AutoComplete', AutoComplete);
app.component('Column', Column);
app.component('Button', Button);
app.component('Checkbox', Checkbox);
app.component('InputText', InputText);
app.component('DataTable', DataTable);
app.component('PanelMenu', PanelMenu);
app.component('TieredMenu', TieredMenu);
app.component('DataView', DataView);
app.component('InputSwitch', InputSwitch);
app.component('InputMask', InputMask);
app.component('ConfirmDialog', ConfirmDialog);
app.component('ProgressBar', ProgressBar);
app.component('Toast', Toast);
app.component('Dropdown', Dropdown);
app.component('Divider', Divider);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Card', Card);
app.component('Dialog', Dialog);
app.component('Avatar', Avatar);
app.component('Toolbar', Toolbar);
app.component('SelectButton', SelectButton);
app.component('Rating', Rating);
app.component('Paginator', Paginator);
app.component('Textarea', Textarea);
app.component('MultiSelect', MultiSelect);
app.component('Chips', Chips);

/////////////////

// filters
import { formatDate, formatCurrency, formatNumber, translate } from './@share/utils/filters';

app.config.globalProperties.$filters = {
    formatDate(value: any, format?: string) {
        return formatDate.func(value, format);
    },
    formatCurrency(value: number | string, symbol?: string) {
        return formatCurrency.func(value, symbol)
    },
    formatNumber(value: number | string) {
        return formatNumber.func(value);
    },
    translate(value: string, langCode?: string) {
        return translate.func(value, langCode);
    }
}

////////////////////

app.use(
    VueAxios,
    axios
);
app.use(store).use(router).mount('#app')

export default app;